import { useEffect } from "react";
import { useMatches } from "react-router";

/**
 * useDocumentTitle Hook
 * Automatically updates the document title based on the current route's breadcrumb
 * Enhances accessibility by providing context to screen reader users
 */
export function useDocumentTitle() {
	const matches = useMatches();

	useEffect(() => {
		const currentMatch = matches[matches.length - 1];
		const handle = currentMatch?.handle as { crumb?: string } | undefined;
		const crumb = handle?.crumb;
		const title = crumb ? `${crumb} - IPS Activos` : "IPS Activos";
		document.title = title;
	}, [matches]);
}
